export default __webpack_public_path__ + "static/media/icon-swift.17e36fe2.png";